import "./AnimatedCheckmark.css";
import React from "react";

export const AnimatedCheckmark = () => (
  <svg className="checkmark" viewBox="0 0 52 52">
    <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
    <path className="checkmark__check" fill="none" d="M10 27l10 10 20-22" />
  </svg>
);
